// extracted by mini-css-extract-plugin
export default {"root":"_2o1u-","img":"_3YgIR"};